exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabContent {\n  display: block;\n  height: calc(100vh - 125px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/reportlist/bundle-stock/bundle.component.scss
// module id = ../../../../../src/app/components/reportlist/bundle-stock/bundle.component.scss
// module chunks = main